import React from 'react';
import { Clock, AlertTriangle, CalendarClock, CalendarX } from 'lucide-react';
import MetricsGrid from '@components/common/MetricsGrid';
import MetricCard from '@components/common/MetricCard';
import type { SchedulerMetricsData } from '@app-types';

interface SchedulerMetricsProps {
  data: SchedulerMetricsData | undefined;
  isLoading: boolean;
}

const SchedulerMetrics: React.FC<SchedulerMetricsProps> = ({ data, isLoading }) => {
  const metrics = [
    {
      id: 'available-late',
      label: 'Available Scheduling Late',
      value: data?.available_scheduling_late ?? 0,
      subtitle: 'Contracts available to schedule, in the late window',
      icon: Clock,
      variant: 'orange' as const
    },
    {
      id: 'available-critical',
      label: 'Available Scheduling Critical',
      value: data?.available_scheduling_critical ?? 0,
      subtitle: 'Contracts available to schedule, critical or overdue',
      icon: AlertTriangle,
      variant: 'red' as const
    },
    {
      id: 'pending-late',
      label: 'Pending Scheduling Late',
      value: data?.pending_scheduling_late ?? 0,
      subtitle: 'Meetings awaiting a date, in the late window',
      icon: CalendarClock,
      variant: 'orange' as const
    },
    {
      id: 'pending-critical',
      label: 'Pending Scheduling Critical',
      value: data?.pending_scheduling_critical ?? 0,
      subtitle: 'Meetings awaiting a date, critical or overdue',
      icon: CalendarX,
      variant: 'red' as const
    }
  ];

  return (
    <MetricsGrid>
      {metrics.map((metric) => {
        const IconComponent = metric.icon;
        return (
          <MetricCard
            key={`metric-${metric.id}`}
            dataTestId={`scheduler-metric-${metric.id}`}
            icon={<IconComponent size={24} />}
            label={metric.label}
            value={metric.value}
            subtitle={metric.subtitle}
            variant={metric.variant}
            loading={isLoading}
          />
        );
      })}
    </MetricsGrid>
  );
};

export { SchedulerMetrics };
